/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "Da destra a sinistra",
		"timeZoneID": "Fuso orario",
		"skin": "Stile",
		"metricsFileImportTask": "Nuova importazione dai file",
		"displayMode": "Vista predefinita",
		"credentialRenewed": "Le credenziali sono state rinnovate con l'ID utente e password corrente.",
		"productLocale": "Lingua prodotto",
		"toggleDisabled": "disattivo",
		"credentialChange": "Rinnova",
		"log_level_Debug": "Debug",
		"confirmNewPassword": "Conferma nuova password",
		"unsavedViewMsg2": "Se non vengono salvate, le modifiche verranno perse.",
		"supportPortalErrorMessage": "Riprovare.  Se il problema persiste, rivolgersi all'amministratore.",
		"legalText": "Licensed Materials - Property of IBM Corp. © Copyright IBM Corporation and other(s) 2005, %{year}. IBM, the IBM logo, ibm.com and Cognos are trademarks or registered trademarks of International Business Machines Corp., registered in many jurisdictions worldwide. A current list of IBM trademarks is available on the Web at www.ibm.com/legal/copytrade.shtml. This Program is licensed under the terms of the license agreement accompanying the Program. This license agreement may be either located in a Program directory folder or library identified as \"License\" or \"Non_IBM_License\" if applicable, or provided as a printed license agreement. Please read the agreement carefully before using the Program. By using the Program you agree to these terms.",
		"groupsAndRoles": "Gruppi e ruoli",
		"metricsMaintenanceTask": "Nuova manutenzione",
		"email": "Posta elettronica",
		"contextual": "Contestuale",
		"resetHome": "Reimposta su valore predefinito",
		"ltr": "Da sinistra a destra",
		"credentials": "Credenziali",
		"logging_congfig_title": "Registrazione",
		"changePasswordTitle": "Modifica password personale",
		"format": "Formato report",
		"showUnread": "Mostra non letto",
		"AILearning_active": "AI Learning è attivo:",
		"docsErrorMessage": "Riprovare.  Se il problema persiste, rivolgersi all'amministratore.",
		"toggleEnabled": "attivo",
		"homeSetError": "Si è verificato un errore durante l'impostazione della home page predefinita, tentare di chiudere e riaprire questa visualizzazione.",
		"passwordChange": "Cambia password",
		"profile": "Profilo",
		"pdfRestricted": "PDF (Limitato)",
		"drillThrough": "Definizioni Drill-Through",
		"homeSet": "Home impostata correttamente",
		"regionalOptions": "Opzioni regionali",
		"myPreferences": "Preferenze personali",
		"defaultHome": "Impostazione predefinita",
		"version": "Versione",
		"controller": "Controller",
		"manage": "Gestisci",
		"biDirectionalFeaturesEnabled": "Supporto lingua bidirezionale",
		"newFeaturesErrorTitle": "Il collegamento a Nuove caratteristiche non ha funzionato",
		"passwordMatch": "Corrispondenza password",
		"updateProfileAndsettings": "Aggiorna profilo e impostazioni",
		"dashboardConsole": "Spazio di lavoro",
		"legacyAppsSlideoutLabel": "Applicazioni legacy disponibili",
		"logging_config_description": "La registrazione viene utilizzata per la risoluzione dei problemi. Consultare il proprio amministratore per assistenza sulle impostazioni.",
		"confirmDeletion": "Conferma eliminazione",
		"signInButtonText": "Esegui l'accesso",
		"dataSourceCredentials": "Credenziali del server di dati",
		"AILearningConfigurationSlideoutAllyLabel": "Configurazione AI Learning",
		"loadingSettings": "Caricamento delle impostazioni",
		"spreadsheetMLRestricted": "Excel (Limitato)",
		"manageAILearning": "AI Learning",
		"xlsxDataRestricted": "Dati Excel (Limitato)",
		"advanced": "Opzioni avanzate",
		"ok": "OK",
		"changeEmail": "Modifica",
		"showHints": "Mostra suggerimenti",
		"general": "Generale",
		"xlsxData": "Dati Excel",
		"newPassword": "Nuova password",
		"hideAll": "Nascondi tutto",
		"confirmPassword": "Conferma password",
		"AILearning_config_description": "Migliora le conoscenze del prodotto consentendo a Cognos Analytics di ottenere informazioni sul tuo utilizzo.",
		"metricStudio": "Applicazione Studio",
		"supportPortalErrorTitle": "Il collegamento al portale di supporto non funziona",
		"log_level_Warn": "Avviso",
		"contentSettings": "Impostazioni contenuto",
		"setHomeButton": "Set",
		"myCapabilities": "Funzioni personali",
		"homePage": "Pagina iniziale",
		"helpErrorMessage": "Riprovare.  Se il problema persiste, rivolgersi all'amministratore.",
		"loadingProfile": "Caricamento del profilo",
		"portal": "Portale",
		"metricsPackage": "Nuovo package",
		"myCredentials": "Credenziali personali",
		"credentialCreate": "Crea",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "Impossibile aggiornare la password",
		"showHiddenObjects": "Mostra voci nascoste",
		"csv": "CSV",
		"docsErrorTitle": "Il collegamento alla documentazione non funziona",
		"log_level_Error": "Errore",
		"wrongPassword": "Impossibile eseguire l'autenticazione",
		"productName": "IBM Cognos Analytics %{version}",
		"log_level_Info": "Informazioni",
		"welcomeBanner": "Banner di benvenuto",
		"helpErrorTitle": "Il collegamento alla Guida non funziona",
		"contentLocale": "Lingua contenuti",
		"pdf": "PDF",
		"oldPassword": "Vecchia password",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "Funzioni di accesso facilitato",
		"manageLogging": "Registrazione",
		"loggingConfigurationSlideoutA11yLabel": "Configurazione della registrazione",
		"communityErrorTitle": "Il collegamento alla Community non funziona",
		"companionApps": "Applicazioni Companion",
		"setHomeLabel": "Imposta pagina iniziale come (vista corrente)",
		"metricsExportTask": "Nuova esportazione",
		"csvRestricted": "CSV (Limitato)",
		"newFeaturesErrorMessage": "Riprovare.  Se il problema persiste, rivolgersi all'amministratore.",
		"contributor": "Contributor",
		"showAll": "Mostra tutto",
		"logging_active": "La registrazione è attiva:",
		"html": "HTML",
		"profileAndSettings": "Profilo e impostazioni",
		"baseTextDirection": "Direzione base per il testo",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "Password",
		"invalidEmail": "Immettere un indirizzo email valido",
		"credentialCreateSuccess": "Le credenziali sono state create correttamente",
		"settings": "Impostazioni",
		"restrictedFormatSelected": "Non si ha la possibilità di eseguire i report in questo formato, ma è possibile accedere ai report salvati in questo formato.",
		"usageDataDeletionConfirmation": "L'eliminazione dei dati di utilizzo ripristina qualsiasi eventuale AI Learning.  Si è sicuri di voler eliminare i dati di utilizzo?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "Visualizza dettagli",
		"deleteUsageData": "Elimina dati di utilizzo:",
		"showPassword": "Mostra password",
		"AILearning_config_title": "AI Learning",
		"myPreferencesSlideoutLabel": "Profilo e impostazioni",
		"passWordChangeSuccess": "La password è stata modificata correttamente",
		"logging_level": "Livello di registrazione:",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "Riprovare.  Se il problema persiste, rivolgersi all'amministratore.",
		"cancel": "Annulla",
		"shareSetError": "Questa azione non può essere eseguita prima della chiusura e riapertura di questa visualizzazione.",
		"passwordNotMatch": "Oops, la password non corrisponde",
		"xml": "XML",
		"xmlRestricted": "XML (Limitato)",
		"openMenu": "Apri menu",
		"closeMenu": 'Chiudi menu'
});